module.exports = __webpack_public_path__ + "img/img_jjfa_zhcs_topimg.19a3deb5.png";